import React, { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';

export const OfflineStatusBanner: React.FC = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="bg-amber-600 text-white text-xs font-semibold py-2 px-4 text-center sticky top-0 left-0 right-0 z-50 animate-in slide-in-from-top duration-300 flex items-center justify-center gap-2">
      <WifiOff className="h-4 w-4 shrink-0" />
      <span>Sin conexión a Internet. Las acciones se guardarán de forma local.</span>
    </div>
  );
};
